<template>
  <div>
    <b-card
      class="p-0 p-sm-4"
      title="Integration Code">

      <integration-prebid-js v-if="zone.integration === 'PREBIDJS'" :zone="zone"/>
      <integration-rtb v-if="zone.integration === 'RTB'" :zone="zone"></integration-rtb>
      <integration-vast v-if="zone.integration === 'VAST'" :zone="zone"></integration-vast>
      <integration-js-tag v-if="zone.integration === 'JSTAG'" :zone="zone"></integration-js-tag>
      <integration-smart-tag v-if="zone.integration === 'PBIAB'" :zone="zone"></integration-smart-tag>
      <b-alert :show="zone.integration === 'PREBIDSERVER'">
        Prebid Server instructions coming soon
      </b-alert>

      <b-card class="col-12 col-md-6 mt-5" bg-variant="light">
        <h5><span class="text-primary icon icon-Support"></span> Need help?</h5>
        <b-row>
          <b-col xl=6>
            <p>We would be more than happy to assist you with technical integrations.</p>
          </b-col>
          <b-col xl=6>
            <b-btn :to="{ name: 'Support' }" size="sm" variant="outline-secondary">Contact Support</b-btn>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <div class="row m-sm-4 my-4">
      <b-col xs="6">
        <b-btn :to="{ name: 'PublisherMediums', params: { cid: cid } }"
          variant="outline-secondary">
          Back To Mediums
        </b-btn>
      </b-col>
    </div>
  </div>
</template>

<style scoped>
  .squared-textarea {
    border-radius: 0.3rem !important;
  }
</style>

<script>
    import ProgressTracker from '@/components/ProgressTracker'
    import IntegrationRtb from './ZoneSettings/Integrations/Rtb'
    import IntegrationPrebidJs from './ZoneSettings/Integrations/Prebidjs'
    import IntegrationVast from './ZoneSettings/Integrations/Vast'
    import IntegrationJsTag from './ZoneSettings/Integrations/JSTag'
    import {PublisherApi} from '@/publisher/api'
    import IntegrationSmartTag from './ZoneSettings/Integrations/SmartTag'

    export default {
        props: {
            cid: {required: true, type: String},
            mid: {required: true, type: String},
            zid: {required: true, type: String}
        },
        data() {
            return {
                progressSteps: [
                    { text: 'General Zone Information' },
                    { text: 'Ad Formats'},
                    {text: 'Global Settings'},
                    {text: 'Integration Code', active: true}
                ],
                medium: {},
                zone: {}
            }
        },
        created() {
            PublisherApi.mediumDetails(this.cid, this.mid).then((med) => {
                this.medium = med
            })
            PublisherApi.tagDetails(this.cid, this.mid, this.zid).then((zone) => {
                this.zone = zone
            })
        },
        components: {
          IntegrationSmartTag,
            ProgressTracker,
            IntegrationRtb,
            IntegrationPrebidJs,
            IntegrationVast,
            IntegrationJsTag,
            IntegrationSmartTag
        }
    }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/TagIntegrationCode.vue